import { useState } from "react";
import { toast } from "sonner";
import { Paperclip, Loader2, Upload, X } from "lucide-react";
import { api, API, getToken } from "@/lib/api";

export function AttachmentsField({ value, onChange, testid }) {
  const items = Array.isArray(value) ? value : [];
  const [busy, setBusy] = useState(false);

  const onPick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/attachments", fd);
      onChange([...items, data]);
      toast.success(`Attached ${data.filename}`);
    } catch {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  const openFile = (id) => window.open(`${API}/attachments/${id}/download?auth=${getToken()}`, "_blank");

  return (
    <div data-testid={testid}>
      {items.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-2">
          {items.map((a) => (
            <div key={a.id} className="flex items-center gap-1.5 bg-muted border border-border rounded-md pl-2 pr-1 py-1 text-xs" data-testid={`attachment-chip-${a.id}`}>
              <button type="button" onClick={() => openFile(a.id)} className="flex items-center gap-1.5 hover:text-brand max-w-[200px] truncate" title={a.filename}>
                <Paperclip className="h-3 w-3 shrink-0" />
                <span className="truncate">{a.filename}</span>
              </button>
              <button type="button" onClick={() => onChange(items.filter((x) => x.id !== a.id))} className="text-muted-foreground hover:text-danger p-0.5" title="Remove" data-testid={`attachment-remove-${a.id}`}>
                <X className="h-3 w-3" />
              </button>
            </div>
          ))}
        </div>
      )}
      <label className="inline-flex items-center gap-2 text-xs cursor-pointer text-brand hover:underline" data-testid="attachment-upload-label">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />}
        {busy ? "Uploading…" : "Add attachment"}
        <input type="file" className="hidden" accept=".pdf,.png,.jpg,.jpeg,.webp,.csv,.xlsx,.xls,.doc,.docx" onChange={onPick} disabled={busy} data-testid="attachment-file-input" />
      </label>
    </div>
  );
}
